export default {
  index: 'Introduction',
  guide: 'Guide',
  reference: 'API',
  examples: 'Examples',
}
